import { FAIcon } from '@/components/fa-icon'
import {
  Command,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
  PopoverContent,
} from '@/components/ui'
import { cn } from '@/lib/utils'
import type { TagNode } from '@/modules/common/types'

interface Props {
  tags: TagNode[]
  selectedIds: string[]
  search: string
  searchPlaceholder: string
  noResultsLabel: string
  onSearchChange(value: string): void
  onToggle(id: string): void
}

export const TagListPopover: React.FC<Props> = ({
  tags,
  selectedIds,
  search,
  searchPlaceholder,
  noResultsLabel,
  onSearchChange,
  onToggle,
}) => {
  const filtered = !search
    ? tags
    : tags.filter(t => t.name.toLowerCase().includes(search.toLowerCase()))

  return (
    <PopoverContent
      className="w-72 p-0"
      align="start"
      onMouseUp={evt => evt.stopPropagation()}
      onTouchEnd={evt => evt.stopPropagation()}
    >
      <Command shouldFilter={false}>
        <CommandInput
          value={search}
          placeholder={searchPlaceholder}
          onValueChange={onSearchChange}
        />
        <CommandList>
          <CommandEmpty>{noResultsLabel}</CommandEmpty>
          <CommandGroup>
            {filtered.map(tag => {
              const isSelected = selectedIds.includes(tag.id)
              return (
                <CommandItem
                  key={tag.id}
                  value={tag.id}
                  onSelect={() => onToggle(tag.id)}
                >
                  <span
                    className="inline-block size-3 rounded-full mr-2 shrink-0 self-center"
                    style={{ backgroundColor: tag.color }}
                  />
                  <span className={cn(isSelected && 'font-semibold')}>
                    {tag.name}
                  </span>
                  <FAIcon
                    className={cn(
                      'ml-auto',
                      isSelected ? 'opacity-100' : 'opacity-0'
                    )}
                    icon="check"
                  />
                </CommandItem>
              )
            })}
          </CommandGroup>
        </CommandList>
      </Command>
    </PopoverContent>
  )
}
